module.exports = __webpack_public_path__ + "static/media/modern3.464e40dc.jpg";